module.exports = __webpack_public_path__ + "static/media/jackpot-mobile.09dbee6c.svg";